var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"iconsize musicpos",class:{rotate:_vm.playing},staticStyle:{"z-index":"100"},attrs:{"src":"res/music.png"},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }